/* BETON & SOUL — motion + collection filter.
   Filter reads data-occasion (occasion metafield + the handles of every collection the product is in).
   Default view = 'featured': only cards tagged featured-home (data-feat). 'all' = everything. */
(function(){
  var root=document.documentElement;
  root.classList.remove('no-js');

  // hero reveal — immediate
  function revealHero(){var h=document.querySelector('.hero');if(h)h.classList.add('in');var hh=document.querySelector('.hero .lines');if(hh)hh.classList.add('in');}
  requestAnimationFrame(revealHero);

  // scroll reveals
  var io;
  function observe(scope){
    var all=(scope||document).querySelectorAll('.rv,.lines');
    if(!('IntersectionObserver' in window)){all.forEach(function(e){e.classList.add('in');});return;}
    if(!io){io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.14,rootMargin:'0px 0px -6% 0px'});}
    all.forEach(function(e){io.observe(e);});
    requestAnimationFrame(function(){all.forEach(function(e){if(e.getBoundingClientRect().top<innerHeight*0.94)e.classList.add('in');});});
  }
  observe(document);

  // sticky header + FAB
  function bindScroll(){
    var top=document.querySelector('.top'),fab=document.querySelector('.fab');
    addEventListener('scroll',function(){var y=scrollY;if(top)top.classList.toggle('solid',y>40);if(fab)fab.classList.toggle('show',y>innerHeight*0.8);},{passive:true});
  }
  bindScroll();

  // collection filter
  var HOLIDAY=['חגי-ישראל','ראש-השנה','פסח','חנוכה'];
  function bindFilter(scope){
    var filt=(scope||document).querySelector('[data-filter]');
    var grid=(scope||document).querySelector('[data-grid]');
    if(!filt||!grid)return;
    function apply(f){
      var hasFeat=!!grid.querySelector('.card[data-feat]');
      grid.classList.toggle('feat4',f==='featured'&&hasFeat);
      grid.querySelectorAll('.card').forEach(function(c){
        if(c.hasAttribute('data-custom')){c.classList.toggle('hide',HOLIDAY.indexOf(f)<0);return;}
        var show;
        if(f==='all') show=true;
        else if(f==='featured') show=hasFeat?c.hasAttribute('data-feat'):true;
        else{var cat=(c.getAttribute('data-occasion')||'').split(/[\s,]+/);show=cat.indexOf(f)>-1;}
        c.classList.toggle('hide',!show);
      });
    }
    filt.addEventListener('click',function(e){
      var b=e.target.closest('.fb'); if(!b)return;
      filt.querySelectorAll('.fb').forEach(function(x){x.classList.toggle('on',x===b);});
      apply(b.getAttribute('data-f'));
    });
    var on=filt.querySelector('.fb.on');
    apply(on?on.getAttribute('data-f'):'all');
  }
  bindFilter(document);

  // Shopify theme editor: re-init a reloaded section
  document.addEventListener('shopify:section:load',function(ev){observe(ev.target);bindFilter(ev.target);requestAnimationFrame(revealHero);});
})();
